import { defineComponent as _defineComponent } from 'vue'
import { dispatchDisableOcrMode } from '@/store/dispatchers/uiDispatchers';


export default /*#__PURE__*/_defineComponent({
  __name: 'OcrModeBar',
  setup(__props) {

const handleClickExit = () => {
  dispatchDisableOcrMode();
};

return { __sfc: true,handleClickExit }
}

})